export const UPDATE_PAGE_MESSAGES = 'UPDATE_PAGE_MESSAGES';
export const UPDATE_JS_MESSAGES = 'UPDATE_JS_MESSAGES';

export const updatePageMessages = (pageMessages) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_PAGE_MESSAGES,
                pageMessages: pageMessages,
            }),
        );
    };
};

export const updateJsMessages = (jsMessages) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_JS_MESSAGES,
                jsMessages: jsMessages,
            }),
        );
    };
};
